import { IBlogSeo } from '@/models/blogPost.model';

export enum BrandsFormFields {
  LOGO = 'logo',
  BANNER = 'banner',
  TITLE = 'title',
  DESCRIPTION = 'description',
  IMAGE_TITLE = 'imageTitle',
  BANNER_TITLE = 'bannerTitle',
  SEO = 'seo',
}

export type TUpdateBrandFormValues = {
  [BrandsFormFields.LOGO]: string | File;
  [BrandsFormFields.BANNER]: string | File;
  [BrandsFormFields.TITLE]: string;
  [BrandsFormFields.DESCRIPTION]: string;
  [BrandsFormFields.IMAGE_TITLE]: string;
  [BrandsFormFields.BANNER_TITLE]: string;
  [BrandsFormFields.SEO]: IBlogSeo;
};
